import React from 'react';

// T0 — Bouton partagé (variants + sizes, dark-mode natif).
const VARIANTS = {
  default: 'bg-blue-500 text-white hover:bg-blue-600',
  outline: 'border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200',
  ghost: 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200',
  danger: 'bg-red-500 text-white hover:bg-red-600',
};

const SIZES = {
  sm: 'h-8 px-3 text-sm',
  default: 'h-10 px-4 py-2',
  lg: 'h-12 px-6',
};

export const Button = ({ children, className = '', variant = 'default', size = 'default', ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none ${VARIANTS[variant] || VARIANTS.default} ${SIZES[size] || SIZES.default} ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
